module.exports = __webpack_public_path__ + "img/signature.9a562f51.gif";